import React, { useContext } from "react";
import Loader from "./Loader";
import PostExcerpt from "./PostExcerpt";
import { LangContext } from "../App";

export default function SearchResults(props) {
  const { data, loading } = props;
  const lang = useContext(LangContext);

  function postExcerpts() {
    const excerpts = data;

    if (excerpts.length === 0) {
      return (
        <div className="search-post not-found">
          <p>
            {lang === "sk"
              ? "Vášmu vyhľadávaniu nezodpovedá žiaden obsah. Skúste znovu."
              : "Nothing found. Please try again."}
          </p>
        </div>
      );
    }

    if (excerpts === false) {
      return (
        <div className="search-post not-found">
          <p>
            {lang === "sk"
              ? "Nastala chyba pri načítavaní. Prosím skúste neskôr."
              : "There is an error in loading. Please try again."}
          </p>
        </div>
      );
    }
    const posts = excerpts.map((post, id) => {
      return <PostExcerpt key={id} post={post} />;
    });

    return posts;
  }

  return (
    <div id="search-results" className={loading ? "loading" : ""}>
      <h3 id="search-results-title">
        {lang === "sk" ? "Výsledky vyhľadávania" : "Search results"}
      </h3>
      <Loader />

      {postExcerpts()}
    </div>
  );
}
